import * as React from 'react';
import * as style from './style.scss';
import {
  CloseRed,
  CmndBack,
  CmndBlur,
  CmndConner,
  CmndFront,
  Step2,
  Step3,
  Step4,
  Step5,
  Step1 as StepOne,
} from 'assets/svg';
import { Fallback, LanguageSwitcher } from 'components/common';
import { IState } from 'redux/global-reducers';
import { Investor } from 'interfaces/ekyc';
import { ListOfSteps } from '../Common/helper';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { detectMob } from '..';
import { handleError } from 'utils/common';
import { selectInvestor } from '../action';
import { withErrorBoundary } from 'react-error-boundary';
import classNames from 'classnames';
import { showNotification } from 'redux/global-actions';
import { ToastType } from 'react-toastify';

const notes = [
  "Document must be valid. It's still in original form and not a copy/scanned copy one.",
  'Place the document in front of the webcam. Adjust the position of the document until the document is properly displayed on your screen.',
  'Ensure your document details are clear to read with no blur or glare.',
  'Please use the computer supporting camera',
];

export interface IStep1Props
  extends React.ClassAttributes<Step1Component>,
    WithNamespaces {
  readonly allowToNextStep: (step: string) => void;
  readonly selectInvestor: typeof selectInvestor;
  readonly showNotification: typeof showNotification;

  readonly checkBlockIpResult: IState['checkBlockIpResult'];
}

export interface IStep1State {
  readonly isShowInto: boolean;
  readonly investor: Investor;
}

class Step1Component extends React.Component<IStep1Props, IStep1State> {
  private isMobile: boolean = false;

  constructor(props: IStep1Props) {
    super(props);
    this.state = {
      isShowInto: false,
      investor: Investor.VN,
    };
    this.isMobile = detectMob();
  }

  render() {
    const { t } = this.props;
    const investor = (
      <>
        <p className={style.Title}>{t('You are Investor?')}</p>
        <div className={style.SelectInvestor}>
          <div className={style.VN}>
            <div
              className={style.SelectBox}
              onClick={() => this.showNotiBlockIp(Investor.VN)}
            >
              <p>{t('Vietnamese Investor')}</p>
            </div>
          </div>
          <div className={style.NN}>
            <div
              className={style.SelectBox}
              onClick={() => this.showNotiBlockIp(Investor.FR)}
            >
              <p>{t('Foreign Investor')}</p>
            </div>
          </div>
        </div>
      </>
    );
    const introduction = (
      <>
        {!this.isMobile && (
          <p className={style.IntroductionTitle}>
            {t(
              'Please take photos of both sides of your ID Card/ Citizen Card/ Passport'
            )}
          </p>
        )}
        <div className={style.NoteSection}>
          <div>
            {notes.map((note, i) => (
              <div className={style.Note} key={i}>
                <div className={style.NoteIndex}>{i + 1}</div>
                <div className={style.NoteText}>{t(note)}</div>
              </div>
            ))}
          </div>
        </div>
      </>
    );
    return (
      <>
        {this.isMobile && this.state.isShowInto && (
          <div className={style.Guide}>
            <progress
              value={15}
              max={100}
              className={style.ProgressBar}
            ></progress>
            <div className={style.GuideTitle}>
              <div>1.</div>
              <div>{t('Guide Info')}</div>
            </div>
            <div className={style.PleaseTake}>
              {t(
                'Please take photos of both sides of your ID Card/ Citizen Card/ Passport'
              )}
            </div>
            <div className={style.PhotoGuide}>
              <div className={style.PhotoGuideStep}>
                <CmndFront />
                <div>{t('Step')} 1:</div>
                <div>{t('Front Face')}</div>
              </div>
              <div className={style.PhotoGuideStep}>
                <CmndBack />
                <div>{t('Step')} 2:</div>
                <div>{t('Back Face')}</div>
              </div>
            </div>
          </div>
        )}
        {this.isMobile && !this.state.isShowInto && (
          <div className={style.LogoSection}>
            <div className={style.Logo} />
          </div>
        )}
        <div
          className={classNames(style.Step1, {
            [style.Step1Mobile]: this.isMobile,
          })}
        >
          {this.state.isShowInto ? introduction : investor}
        </div>
        {this.isMobile && !this.state.isShowInto && (
          <div className={style.StepRegister}>
            <p className={style.StepTitle}>{t('Step register')}</p>
            <div className={style.StepEvery}>
              <StepOne />
              <p>{t('Step')} 1:</p>
              <p>{t('Scan ID Card/ Passport')}</p>
            </div>
            <div className={style.StepEvery}>
              <Step2 />
              <p>{t('Step')} 2:</p>
              <p>{t('Face Recognition')}</p>
            </div>
            <div className={style.StepEvery}>
              <Step3 />
              <p>{t('Step')} 3:</p>
              <p>{t('Personal Information')}</p>
            </div>
            <div className={style.StepEvery}>
              <Step4 />
              <p>{t('Step')} 4:</p>
              <p>{t('Service Registration')}</p>
            </div>
            <div className={style.StepEvery}>
              <Step5 />
              <p>{t('Step')} 5:</p>
              <p>{t('OTP Authentication')}</p>
            </div>
            <div className={style.Language}>
              <div>{t('Language')}:</div>
              <LanguageSwitcher />
            </div>
          </div>
        )}
        {this.isMobile && this.state.isShowInto && (
          <div className={style.PhotoRule}>
            <div className={style.PhotoRuleStep}>
              <CmndFront />
              <p>{t("Don't take too blurry photos")}</p>

              <CloseRed />
            </div>
            <div className={style.PhotoRuleStep}>
              <CmndConner />
              <p>{t("Don't take missing-corner photos")}</p>
              <CloseRed />
            </div>
            <div className={style.PhotoRuleStep}>
              <CmndBlur />
              <p>{t("Don't take over exposure photos")}</p>
              <CloseRed />
            </div>
          </div>
        )}
      </>
    );
  }

  private showNotiBlockIp = (investorType: Investor) => {
    if (this.props.checkBlockIpResult.blocked) {
      this.props.showNotification({
        type: ToastType.ERROR,
        title: 'Block Ip',
        content: this.props.t('Please try again in 1 hour'),
        time: new Date(),
      });
    } else {
      this.chooseInvestor(investorType);
    }
  };

  private chooseInvestor = (investor: Investor) => {
    this.setState({ isShowInto: true, investor });
    this.props.selectInvestor(investor);
    this.props.allowToNextStep(ListOfSteps.InvestorGuide);
  };
}

const mapStateToProps = (state: IState) => ({
  checkBlockIpResult: state.checkBlockIpResult,
});

const Step1 = withErrorBoundary(
  withNamespaces('common')(
    connect(mapStateToProps, { selectInvestor, showNotification })(
      Step1Component
    )
  ),
  Fallback,
  handleError
);

export default Step1;



// WEBPACK FOOTER //
// ./src/screens/KisEkyc/Step1/index.tsx